import { RichTextBlock } from "graphql/generated-types";

const RichText = ({ block }: { block: RichTextBlock }) => {
	return (
		<article className="container grid-cols-3 lg:grid">
			<div className="col-span-2 prose lg:text-lg max-w-none" dangerouslySetInnerHTML={{ __html: block.value }} />
		</article>
	);
};

export default RichText;
